import { render, staticRenderFns } from "./passenger-field.vue?vue&type=template&id=2405a548&scoped=true"
import script from "./passenger-field.vue?vue&type=script&lang=js"
export * from "./passenger-field.vue?vue&type=script&lang=js"
import style0 from "./passenger-field.vue?vue&type=style&index=0&id=2405a548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405a548",
  null
  
)

export default component.exports